import { Inject, Injectable } from '@angular/core';
import { jsonPaths, urlPaths } from '../../../services/api/api.url';
import { Observable } from 'rxjs';
import { ContentPageText } from './definitions';
import { HttpClient } from '@angular/common/http';
import { expEnvironmentRef } from '../../../injection-tokens/environment.injection-token';
import { ApiResponse } from '../../../definitions/api-response.interface';
import { EnvironmentRef } from 'projects/tmhna-portal/src/environments/interfaces';

@Injectable({
	providedIn: 'root'
})
export class PrivacyAndTermsAndConditionsService 
{
	constructor(private readonly httpClient: HttpClient, @Inject(expEnvironmentRef) readonly environmentRef: EnvironmentRef) { }

	getContentPageData(): Observable<ContentPageText> 
	{
		const url = jsonPaths.contentPageLabels;
		return this.httpClient.get<ContentPageText>(url);
	}

	getPrivacyPolicyData() 
	{
		const url: string =
		this.environmentRef.baseUrl + urlPaths.cmsPolicyData;
		return this.httpClient.get<ApiResponse>(url);
	}

	getTermsAndConditionsData() 
	{
		const url: string =
			this.environmentRef.baseUrl + urlPaths.cmsTnCdata;
		return this.httpClient.get<ApiResponse>(url);
	}
}
